function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { Constants } from '@shared/utils/constants';
import { launchTelemetry } from '@shared/utils/reviewsUtils';
import { logger } from '@src/logger';
import { ReviewMarkAsHelpfulModalErrorDialog } from './reviewMarkAsHelpfulModalErrorDialog';
export function ReviewMarkAsHelpfulModal({ payload, dismissModal }, context) {
    const dismissModalWithTelemetry = ()=>{
        launchTelemetry(Constants.Telemetry.Action.Close, Constants.Telemetry.ActionModifier.ReviewItemMarkAsHelpfulDialog, {
            payload
        });
        logger.info(JSON.stringify({
            payload
        }), {
            action: Constants.Telemetry.Action.Close,
            actionModifier: Constants.Telemetry.ActionModifier.ReviewItemMarkAsHelpfulDialog
        });
        dismissModal();
    };
    const innerDialogProps = {
        dismissModal: dismissModalWithTelemetry,
        context,
        payload
    };
    return /*#__PURE__*/ _jsx(ReviewMarkAsHelpfulModalErrorDialog, _object_spread({}, innerDialogProps));
}
ReviewMarkAsHelpfulModal.contextTypes = {
    loc: PropTypes.func
};
